module.exports = __webpack_public_path__ + "img/icon_img_delete.ba58896a.svg";